import { render, staticRenderFns } from "./activities_notification.vue?vue&type=template&id=964e2c6c&scoped=true&"
import script from "./activities_notification.vue?vue&type=script&lang=js&"
export * from "./activities_notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964e2c6c",
  null
  
)

export default component.exports